(() => {
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;

  const arrangeGallery = (gallery) => {
    if (!desktop() || gallery.dataset.cardcPdpGallery === 'ready') return;
    const grid = gallery.querySelector('.media-gallery__grid');
    if (!grid || grid.children.length < 2) return;
    const applyGridRows = () => {
      const items = Array.from(grid.children);
      const thumbnailCount = Math.max(items.length - 1, 1);
      grid.style.setProperty('--cardc-pdp-thumb-count', String(thumbnailCount));
      items.forEach((item, index) => {
        item.style.gridRow = index === 0 ? '1 / span ' + thumbnailCount : String(index);
        item.style.alignSelf = 'start';
      });
    };
    const applyActive = (active) => {
      Array.from(grid.children).forEach((item) => {
        item.dataset.cardcPdpActive = item === active ? 'true' : 'false';
      });
    };
    const selectItem = (item, event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (item !== grid.firstElementChild) grid.insertBefore(item, grid.firstElementChild);
      applyGridRows();
      applyActive(item);
    };
    Array.from(grid.children).forEach((item) => {
      item.querySelectorAll('button.product-media-container__zoom-button').forEach((button) => {
        button.tabIndex = -1;
        button.setAttribute('aria-hidden', 'true');
        button.style.pointerEvents = 'none';
      });
      item.addEventListener('click', (event) => selectItem(item, event), true);
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') selectItem(item, event);
      }, true);
    });
    applyGridRows();
    applyActive(grid.firstElementChild);
    gallery.dataset.cardcPdpGallery = 'ready';
  };

  const init = () => {
    document.querySelectorAll('[data-cardc-amazon-pdp]').forEach((root) => {
      const details = document.querySelector('[data-testid="product-information-details"]');
      const facts = root.querySelector('[data-cardc-pdp-facts]');
      const form = details?.querySelector('product-form-component');
      if (facts && form && !details.contains(facts)) form.after(facts);
      const sizePanel = root.querySelector('[data-cardc-variant-sizes]');
      if (sizePanel && details && sizePanel.dataset.cardcVariantSizes !== 'ready') {
        const showSelectedSize = () => {
          const selectedValue = details.querySelector('input[type="radio"]:checked')?.value;
          if (!selectedValue) return;
          sizePanel.querySelectorAll('[data-cardc-variant-size-value]').forEach((item) => {
            item.hidden = item.dataset.cardcVariantSizeValue !== selectedValue;
          });
        };
        details.addEventListener('change', (event) => {
          if (event.target instanceof HTMLInputElement && event.target.type === 'radio') requestAnimationFrame(showSelectedSize);
        });
        showSelectedSize();
        sizePanel.dataset.cardcVariantSizes = 'ready';
      }
      document.querySelectorAll('media-gallery').forEach(arrangeGallery);
      root.dataset.cardcPdpReady = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState !== 'loading') init();
})();